import { LOCAL_STORAGE } from '@/constants/app.constants';
import type { AddressMatch } from '@/services/apis/addressSearch/schemas';

export const parseLocalStorageSelectedAddress = () => {
  const selectedAddress = localStorage.getItem(LOCAL_STORAGE.SELECTED_ADDRESS);
  if (!selectedAddress) {
    return null;
  }
  try {
    return JSON.parse(selectedAddress) as AddressMatch;
  } catch {
    return null;
  }
};

export const storeLocalStorageSelectedAddress = (
  selectedAddress: AddressMatch
) => {
  try {
    localStorage.setItem(
      LOCAL_STORAGE.SELECTED_ADDRESS,
      JSON.stringify(selectedAddress)
    );
  } catch {
    console.error('Something went wrong storing selected address');
  }
};
